import React from 'react';
import logoArbor from './../../../public/Images/Imgarbor.png';
import './site.css';

function Features() {
  return (
    <section id="features">
      <div className="features-title">
        <h2>Plataformas e Acessos</h2>
        <p>Selecione o módulo desejado para continuar</p>
      </div>

      <div className="row g-4 justify-content-center">
        {/* Parceiros */}
        <div className="col-lg-4 col-md-6">
          <a href="/parceria/login" className="feature-card">
            <div className="feature-icon-box">
              <i className="fa fa-users" />
            </div>
            <h3>Parceiros</h3>
            <p>Acesse o portal de parceiros de descontos <b>Floresta Supermarket</b></p>
          </a>
        </div>

        {/* Arbor Web */}
        <div className="col-lg-4 col-md-6">
          <a href="/arbor/login" className="feature-card">
            <div className="feature-icon-box">
              <img src={logoArbor} alt="Arbor" className="feature-icon-img" />
            </div>
            <h3>Arbor Web</h3>
            <p>Acesse o sistema de gestão integrada <b>ARBOR WEB</b></p>
          </a>
        </div>

        {/* Restaurantes */}
        <div className="col-lg-4 col-md-6">
          <a href="/restaurante/login" className="feature-card">
            <div className="feature-icon-box">
              <i className="fa fa-cutlery" />
            </div>
            <h3>Restaurantes</h3>
            <p>Portal exclusivo para parceiros de restaurantes e refeições</p>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Features;